import PropTypes from 'prop-types';

export default PropTypes.shape({
  parentUuid: PropTypes.string,
  productId: PropTypes.string,
  productVersion: PropTypes.string,
  paidThrough: PropTypes.number
});


// WEBPACK FOOTER //
// ./src/shapes/batch-product-instance.js